'use client';

import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

export interface CategoryMedia {
  type: 'image' | 'video';
  src: string;
  alt?: string;
  poster?: string; // For video poster image
}

export interface Category {
  id: string | number;
  title: string;
  description: string;
  media?: CategoryMedia;
  color?: string;
}

interface CategoryContextType {
  selectedCategory: Category | null;
  setSelectedCategory: (category: Category | null) => void;
  categories: Category[];
  setCategories: (categories: Category[]) => void;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export function CategoryProvider({ children }: { children: ReactNode }) {
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);
    useEffect(() => {
       console.log('categories', selectedCategory);
       
    }, [selectedCategory]);
  return (
    <CategoryContext.Provider value={{
      selectedCategory,
      setSelectedCategory,
      categories,
      setCategories
    }}>
      {children}
    </CategoryContext.Provider>
  );
}

export function useCategory() {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
}
